import PropTypes from 'prop-types'

Copyright.propTypes = {
  author: PropTypes.string.isRequired,
  fromYear: PropTypes.string
}

export default function Copyright ({ author, fromYear }) {
  const currentYear = new Date().getFullYear()
  const years = fromYear ? `${fromYear}-${currentYear}` : currentYear

  return (
    <center>
      © {author}, {years}
      <br/>Все права защищены.
    </center>
  )
}
